import { useTranslation } from "react-i18next";

function WarningIcon() {
	return (
		<svg
			width="30"
			height="30"
			viewBox="0 0 30 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path
				d="M15 11.25V16.25M15 20H15.0125M26.25 15C26.25 21.2132 21.2132 26.25 15 26.25C8.7868 26.25 3.75 21.2132 3.75 15C3.75 8.7868 8.7868 3.75 15 3.75C21.2132 3.75 26.25 8.7868 26.25 15Z"
				stroke="#B58105"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

interface OutageBannerProps {
	testId?: string;
}

export function OutageBanner({ testId = "outage-banner" }: OutageBannerProps) {
	const { t } = useTranslation("common");

	return (
		<div
			className="flex items-start gap-2 rounded-lg bg-warning-100 p-3"
			data-testid={testId}
		>
			<div className="flex-shrink-0">
				<WarningIcon />
			</div>
			<p className="flex-1 text-body-sm-medium text-gray-700">
				{t("outageBanner.message")}
			</p>
		</div>
	);
}
